document.addEventListener( 'DOMContentLoaded', function () {
	const accordionDetails = document.querySelectorAll( '.accordion-details' );
	accordionDetails && accordionDetails.forEach( details => {
		details.addEventListener( 'toggle', function( event ) {
			if ( this.hasAttribute('open') ) {
				this.querySelector('summary').setAttribute('aria-expanded', true);
			} else {
				this.querySelector('summary').setAttribute('aria-expanded', false);
			}
		} );
	} );
} );